import React from 'react';
import { useAuth } from '../../hooks/auth';
import { UserRole } from '../../types/auth';
import StudentAnalytics from './components/StudentAnalytics/StudentAnalytics';
import SuperAdminAnalytics from './components/SuperAdminAnalytics/SuperAdminAnalytics';

const Analytics: React.FC = () => {
    const { user } = useAuth()!;

    if (!user) return null;

    switch (user.role) {
        case UserRole.SUPER_ADMIN:
            return <SuperAdminAnalytics />;
        case UserRole.SCHOOL_ADMIN:
            // For now, let's show PlatformAnalytics or StudentAnalytics or a placeholder
            // Usually School Admin would have their own, but let's default to Student for now or Platform if they are similar
            return <div>School Admin Analytics</div>;
        case UserRole.STUDENT:
            return <StudentAnalytics />;
        default:
            return <div style={{ color: 'white', padding: '20px' }}>Analytics not available for this role.</div>;
    }
};

export default Analytics;
